import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import { NamedLink } from '../../components';

import css from './StripeVerificationBanner.module.css';

// Redundant on the payout page itself — that page already shows the
// "Fullfør verifisering" status box, so a banner pointing back to it
// would be noise. Search pages are excluded for the same layout reason
// as LimitedAccessBanner (a top strip breaks their fixed layout).
const disabledPages = ['StripePayoutPage', 'SearchPage', 'SearchPageWithListingType'];

/**
 * Global banner shown to a seller whose Stripe connected account has
 * outstanding verification requirements (e.g. Stripe asked for more info
 * after the account was already set up). Surfaces it app-wide so the
 * seller is told their payouts are at risk without having to visit the
 * payout settings page, and links straight there.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName]
 * @param {string} [props.className]
 * @param {boolean} props.show - Whether verification is outstanding.
 * @param {string} [props.currentPage]
 * @returns {JSX.Element|null}
 */
const StripeVerificationBanner = props => {
  const { rootClassName, className, show, currentPage } = props;

  if (!show || disabledPages.includes(currentPage)) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <p className={css.text}>
        <FormattedMessage id="StripeVerificationBanner.message" />
      </p>
      <NamedLink name="StripePayoutPage" className={css.link}>
        <FormattedMessage id="StripeVerificationBanner.link" />
      </NamedLink>
    </div>
  );
};

export default StripeVerificationBanner;
